fx.ns("desktop.calendar", class CalendarBoard extends desktop.common.board.Board 
{
    constructor(model, componentFactory, options) 
    {
        super(model, componentFactory, options);

        this.allowScrollUpdates();
    }

    /**************************** Getters / Setters **********************/

    get calendarCreation() {
        return this.data;
    }

    set calendarCreation(val) {
        this.data = val;
    }

    get allChilds() {
        if (!this.initialized || !this.cover)
            return [];

        if (!this._allChilds) {
            this._allChilds = [];

            this._allChilds.push(this.cover);

            this.pages.sort(function (a, b) {
                return (a.data.number - b.data.number);
            });

            this._allChilds.push.apply(this._allChilds, this.pages);

            this._allChilds.push(this._emptyMarginElement);
        }

        return this._allChilds;
    }

    get currentView() {
        if (!this._currentView)
            this._currentView = new desktop.calendar.CalendarView(this);

        return this._currentView;
    }

    get currentArea() {
        if (!this._currentArea)
            this.resolveCurrentArea();

        return this._currentArea;
    }

    set currentArea(val) {
        if (this._currentArea == val /*|| !val*/)
            return;

        if (this._currentArea) {
            this._currentArea.active = false;
            this.currentArea.activePart = "";
        }

        this._currentArea = val;

        //if (this._currentArea)
        //    this._currentArea.active = true;

        this.currentElement = null;

        this.guidelines.currentArea = this._currentArea;

        if (this.model.history && this._currentArea)
            this.model.history.currentPage = this._currentArea.data;

        if (this._currentArea)
            this.trigger("currentAreaChanged", this._currentArea);
    }

    /*************************** Overrides  *************************/

    buildBoard() {
        this.removeAllEditableAreas();

        if (!this.calendarCreation || !this.calendarCreation.cover || !this.calendarCreation.elements) return;

        // Calendars that show only one page
        if (this.calendarCreation.isSinglePage)
        {
            this.cover = new shared.stage.CalendarSingleArea(0, this.calendarCreation.cover, this.model, this);
            this.addEditableArea(this.cover, { width: this.calendarCreation.pageWidth, height: this.calendarCreation.pageHeight });

            // Pages
            let pages = this.calendarCreation.innerPages;
            this.pages = [];

            for (let i = 0; i < 12; i++) {
                let page = new shared.stage.CalendarSingleArea(i, pages.getItemAt(i), this.model, this);
                page.effect = "fade";
                this.pages.push(page);
                this.addEditableArea(page, { width: this.calendarCreation.pageWidth, height: this.calendarCreation.pageHeight });
            }
        }
        else // calendars that are open (show cover closed, and then 2 open pages)
        {
            // Cover
            this.cover = new shared.stage.CalendarCover(0, this.calendarCreation.cover, this.model, this);
            this.addEditableArea(this.cover, { width: this.calendarCreation.pageWidth, height: this.calendarCreation.pageHeight });

            // Pages
            let pages = this.calendarCreation.innerPages;
            this.pages = [];

            for (let i = 0; i < 12; i++) {
                let page = new shared.stage.CalendarArea(i, pages.getItemAt(i), this.model, this);
                page.effect = "fade";
                this.pages.push(page);
                this.addEditableArea(page, { width: this.calendarCreation.pageWidth, height: this.calendarCreation.pageHeight * 2 });
            }
        }

        // used to keep a margin at the bottom and not having any scroll problem when adding new page
        this._emptyMarginElement = new fx.components.Box("EmptyMargin");
        this.addChild(this._emptyMarginElement, { width: "80%", height: "400" });

        this.currentView.update(false);
    }

    onReady()
    {
        super.onReady();;
    }

    getArea() {
        return this.currentArea;
    }

    addEditableArea(area, viewport, position)
    {
       super.addEditableArea(area, viewport, position);

        this.on("select", this.onSelect, area);
    }

    removeEditableArea(area)
    {
        super.removeEditableArea(area);

        if (area)
            this.off("select", this.onSelect, area);
    }

    removeAllEditableAreas()
    {
        let area;
        while(area = this._editableAreas.pop())
        {
            this.off("select", this.onSelect, area);
            this.removeChild(area, true);
        }
    }

    getArea(id)
    {
        for (let i = 0; i < this._editableAreas.length; i++)
        {
            if (this._editableAreas[i].id == id)
                return this._editableAreas[i];
        }
    }

    getAreaForPage(id)
    {
        for (let i = 0; i < this._editableAreas.length; i++)
        {
            if (this._editableAreas[i].data && this._editableAreas[i].data.id == id)
                return this._editableAreas[i];
        }
    }

    onSelect(event)
    {
        let area = event.detail ? event.detail.area : event.area;
        let element = event.detail ? event.detail.element : event.element;

        this.currentArea = area;
            
        this.currentElement = element;

        this._mouse.selectedElement = element;
        this._mouse.selectedArea = area;

        if (this.currentArea && event.originalEvent)
            this.currentArea.selectActivePart(event.originalEvent);

        //if (this.currentElement && this.currentElement.data.isPhoto && this.currentElement.empty)
        //{
            // let show photo galery
            //fx.set("photo-selected", this.currentElement);

            //this.data.event("selectphotos");
        //}
    }

    _onEditEvent()
   {
        this._editEvent.model.event("edit-event-calendar", this._editEvent.detail);
   } 

    onDataEvent(event) {
        super.onDataEvent(event);

        if (event.type == "select-event-calendar")
        {
            let area = this.getAreaForPage(event.detail.page.id);
            this.currentView.select(area, false);

            this._editEvent = event;
            this.delay(this._onEditEvent, 250);
        }

        if (event.type == "add-component") // component added by clicking or dropping
        {
            if (event.data.area)
                this.currentArea = this.getAreaForPage(event.data.area);
        
            // TODO : if photo is clicked on gallery, first try to find if there is some empty picture and fill it
            // if not photo is empty, get new layout with number of picture, apply it and add new photo
             if (event.detail.component_type == "text")
                this._addTextComponent( event.detail );
            else
            if (event.detail.component_type == "photo" && event.detail.creation != "dropped") 
            {
                if (this.currentElement && this.currentElement.data && this.currentElement.data.isPhoto) 
                    this.currentElement.data.content = event.detail.content;
                else
                {
                    let photosComponents = this.currentArea.data.photosComponents;

                    photosComponents = photosComponents.sort( (a, b) => (b.width * b.height) - (a.width * a.height) );

                    let emptyPhotos = photosComponents.filter( a => a.content == "");

                    if (emptyPhotos.length > 0)
                    {
                        emptyPhotos.sort( (a, b) => a.x - b.x );
                        emptyPhotos.getItemAt(0).content = event.data.content;
                    }
                    else
                    if (photosComponents.length > 0)
                        photosComponents.getItemAt(0).content = event.data.content;
                }
            }
            else // if not photo or photo dropped
            {
                this._photoIndex = undefined;
                if (event.detail.page)
                    delete event.detail.page;

                this.currentElement = null;

                this.currentArea.active = true;
                this.currentArea.addComponent(event.detail);
            }
        }

        if (event.type == "apply-layout") 
        {
            let layout = this.model.layouts.find({ id: event.detail.content });

             if (event.data.area)
                this.currentArea = this.getAreaForPage(event.data.area);

             if (!this.currentArea)
             {
                let activeAreas = this.currentView.scroll();
                this.currentArea = activeAreas[0];
             }

            if (this.currentArea)
            {
                this.currentArea.active = true;
                this.currentArea.applyLayout(layout /*, this.currentArea.activePart*/);
            }

            event.cancel(); // so layout is not applied somewhere else
        }

    }

    resolveCurrentArea() {
        this.currentArea = this.currentView.scroll(true)[0];
    }

    /*************************** Events  *************************/



    onClick(event) {
    }


    
    onScroll()
    {
        this.trigger("scrolled");

        let activeAreas = this.currentView.scroll();

        if (!this._scrollUpdateEnabled) return;
        
        if (!activeAreas.contains(this.currentArea))
            this.currentArea = activeAreas[0];
    }
    


    _editCurrentElement() {
        if (this.currentElement instanceof shared.stage.components.Text)
            this.currentElement.onEdit();
    }


    _addTextComponent(data)
    {
        let text = this.model.texts.find({id : data.contentid || data.content}, this.model);
        if (text)
        {
            data.content = text.content;
            data.content_type = text.content_type;
            data.text_color = text.text_color;
            data.font_family = text.font_family;
            data.width = text.text_width;
            data.height = text.text_height;
            data.font_size = text.font_size;
            data.align = text.align;

            if (data.area)
                this.currentArea = this.getAreaForPage(data.area);
            
            this.currentArea.addComponent( data, data.side );
        }
    
    }



});